<template>
  <hypto-popup :title="type + ' Options'">
    <template v-slot:body>
      <div class="merge-fields">
        <label class="custom-label" :class="{'has-value': date}">Created Date Range</label>
        <date-picker v-model="date" type="date" :class="{'has-value': date}"
                    range range-separator=" to " format="YYYY-MM-DD"
                    confirm confirm-text="Apply" />
      </div>
    </template>

    <template v-slot:footer>
      <button class="dark-btn" @click="reset">Reset</button>
      <button class="primary-btn" @click="doAction">{{type}}</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

import moment from 'moment'
import { mapGetters } from 'vuex'
import ApiServices from '@/services/api/upi'

export default {
  name: 'UpiExportFilter',
  components: { HyptoPopup, DatePicker },
  data () {
    return {
      type: null,
      date: null
    }
  },
  created () {
    if (this.getterStatementFilter.hasOwnProperty('date_range')) {
      this.date = this.getterStatementFilter['date_range'].split('to')
      this.date = this.date.map(entry => new Date(entry.trim()))
    }
  },
  computed: {
    ...mapGetters(['getterPopupName', 'getterStatementFilter'])
  },
  watch: {
    getterPopupName: {
      handler (newVal) {
        if (newVal === 'UpiFilter') {
          this.type = 'Filter'
        } else if (newVal === 'UpiExport') {
          this.type = 'Export'
        }
      },
      immediate: true
    }
  },
  methods: {
    doAction () {
      let params = {}
      if (this.date && !this.date.includes(null)) {
        params['date_range'] = moment(this.date[0]).format('YYYY-MM-DD') + ' to ' + moment(this.date[1]).format('YYYY-MM-DD')
      }
      this.$emit('updateFilters', params)

      if (this.type === 'Export') {
        this.export(params)
      }
    },
    export (params) {
      ApiServices.exportUpi(params).then((response) => {
        if (response.success) {
          this.successToastMsg(response.message)
        }
      })
    },
    reset () {
      this.date = null
    }
  }
}
</script>
